import React from 'react';
import styles from './checkbox.module.css';

const CheckBox = ({ type = 'checkbox', label, name, register, value, defaultChecked }) => {
  return (
    <div className={styles.checkBox}>
      <input type={type} name={name} defaultChecked={defaultChecked} value={value} ref={register} />
      <label>{label}</label>
    </div>
  );
};

export default CheckBox;
